import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { BranchContactComponent } from '../branch-contact/branch-contact.component';
import { BranchGstDetailsComponent } from '../branch-gst-details/branch-gst-details.component';
import { IEntityBranch, IEntityBranchCriteria } from '../external-entity.interface';
import { KycDetailsComponent } from '../kyc-details/kyc-details.component';
import * as _ from "underscore";
import { SEZComponent } from '../sez/sez.component';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { Message } from 'src/app/shared/constants/message';

@Component({
    selector: 'app-entity-branch-list',
    templateUrl: './entity-branch-list.component.html',
    styleUrls: ['./entity-branch-list.component.less'],
    standalone: false
})
export class EntityBranchListComponent implements OnInit {

  
  constructor(private formBuilder:FormBuilder,private logger:NGXLogger,
              private service:DataService,private utilityService:UtilityService,
              private router:Router,private activatedRoute:ActivatedRoute,
              private dailog:MatDialog,private permissionService:PermissionService) { }

  entityBranchColumns=['code','name','location','city','sez','details','gst','contact','kyc','deactivate','status'];
  entityBranchListForm:FormGroup;
  criteria:IEntityBranchCriteria={};
  pageSizeOptions=this.utilityService.getPageSizeOptions();
  branchList:any;
  entityBranchDataSource=new MatTableDataSource<IEntityBranch>();
  totalRecords:any;
  checked: boolean = false;
  showDeactivateToggle: boolean = false;
  showReactivateToggle: boolean = false;
  message:string;
  entityId:number;
  countryId:number;
  @Input() buttonHidden:boolean=false;
  @Input() url:any;
  @Input() set entityIdFromEntity(id:number){
     this.criteria.entiyId=id;
     this.getEntityBranchList();
  }
  @Input() disableTable:boolean=false;
  editPermission: boolean = false;
  deactivatePermission: boolean = false;
  reactivatePermission: boolean = false;

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        this.logger.info('Entity Id in Branch List',+param['id']);
        this.entityId=+param['id'];
        this.getEntityById();
    });
    this.criteria.entityIds=[this.entityId];
    this.entityBranchListForm=this.formBuilder.group({     
   })
   this.getEntityBranchList();
   this.getAllPermissions();
  }

  sortData(event:any){
    this.criteria.sort=[event.active,event.direction];
    this.getEntityBranchList();
  }

  cancel(){
    this.router.navigate(['../../'],{relativeTo:this.activatedRoute});
  }

  openGST(branchId:number){
    const dailogRef=this.dailog.open(BranchGstDetailsComponent,{
      data:branchId,
      width:'50%',
      height:'50%'
    });
  }

  openContact(branch: any){
    this.logger.info('branch by id', branch?.id);
    const dailogRef=this.dailog.open(BranchContactComponent,{
      data: { branchId: branch?.id, disableTable: branch?.status === 'DEACTIVATED', showCloseButton: true },
      width:'70%',
      height:'60%'
    });
  }

  openKYC(branchId:number){
    let data={countryId:this.countryId,branchId:branchId,referenceName:'Entity Branch'};
    const dailogRef=this.dailog.open(KycDetailsComponent,{
      data:data,
      width:'70%',
      height:'60%'
    });
  }

  openSEZ(branchId:number){
    const dailogRef=this.dailog.open(SEZComponent,{
      data:branchId,
      width:'65%',
      height:'30%'
    });
  }

  openBranchDetails(id:number){
    if(this.editPermission){
      this.activatedRoute.queryParams.subscribe(params => {
        if(params['location']=='list'){
          this.router.navigate(['../../'+'edit/'+this.entityId+'/editBranch/'+id],{relativeTo:this.activatedRoute,queryParamsHandling:'merge',queryParams:{id:this.entityId}});
        }
        if(params['location']=='edit'){
          this.router.navigate(['editBranch/'+id],{relativeTo:this.activatedRoute,queryParams:{location:'edit'}});
        }
      });
    } else
      this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
  }

  openDeactivateForm(e:MatSlideToggleChange,id:number){
    if(this.deactivatePermission){
      let data={id:id,route:'Close',message:'Entity Branch',api:Api.ENTITY_BRANCH_DEACTIVATE}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload();
        } else {
          const branch = this.branchList.find(b => b.id === id);
          if (branch) { branch.checkedDeactivate = false; }
        }
      });
    } else
        this.utilityService.notifier(Message.DEACTIVATE_PERMISSION_WARNING,"warning");
  }

  openReactivateForm(e:MatSlideToggleChange,id:number){
    if(this.reactivatePermission){
      let data={id:id,route:'Close',message:'Entity Branch',api:Api.ENTITY_BRANCH_REACTIVATE}
      const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(result => {
        if (result === true) {
          window.location.reload();
        } else {
          const branch = this.branchList.find(b => b.id === id);
          if (branch) { branch.checkedReactivate = false; }
        }
      });
    } else
        this.utilityService.notifier(Message.ACTIVATE_PERMISSION_WARNING,"warning");
  }
 
  getEntityById(){
    if(this.entityId){
      this.service.get(Api.EXTERNAL_ENTITY+'/'+this.entityId).subscribe(res => {
        this.countryId=res.address.countryId;
      })
    } 
  }

  getEntityBranchList(){
    this.service.get(Api.ENTITY_BRANCH_LIST,this.criteria).subscribe(res => {
      res.forEach(branchObj => {
        branchObj['countryName']=branchObj.address.countryName;
        branchObj['cityName']=branchObj.address.cityName;
        branchObj['message']=this.getStatus(branchObj);
        branchObj['showDeactivateToggle'] = branchObj.status === 'APPROVED' && !branchObj.submittedForApproval;
        branchObj['showReactivateToggle'] = branchObj.status === 'DEACTIVATED' && !branchObj.submittedForApproval;
        branchObj['checkedDeactivate'] = false;
        branchObj['checkedReactivate'] = false;
      });
      this.entityBranchDataSource=res;
      this.branchList=res;
    })
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivateDtls?.deactivationWefDate,
        reactivationWefDate: data.reactivateDtls?.reactivationWefDate});
    }
  }

  public getAllPermissions(){
    const permissionCodes=[PermissionKey.ENTITY_BRANCH_EDIT_PERMISSION,PermissionKey.ENTITY_BRANCH_DEACTIVATE_PERMISSION,
      PermissionKey.ENTITY_BRANCH_REACTIVATE_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.ENTITY_BRANCH_MODULE);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_EDIT_PERMISSION})?.show?true:false; 
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_REACTIVATE_PERMISSION})?.show?true:false; 
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.ENTITY_BRANCH_DEACTIVATE_PERMISSION})?.show?true:false; 
  }

}
